import instance from "@/services/api";

export const contractorAgreementListAPI = {
  async getList() {
    return await instance().get('/handbook/contractor_agreement_list/read/').then(res => res?.data)
  },
  async save(data) {
    return await instance().post('/handbook/contractor_agreement_list/save/', data).then(res => res?.data)
  },
  async delete(contractor_agreement_list_id) {
    return await instance().delete(`/handbook/contractor_agreement_list/${contractor_agreement_list_id}/delete/`).then(res => res?.data)
  },
  async getContractors() {
    return await instance().get('/project_list/contractors/read/').then(res => res?.data)
  },
  async getProviders() {
    return await instance().get('/handbook/providers/read/').then(res => res?.data)
  },
  async getSbsProjects() {
    return await instance().get('/handbook/contractor_agreement_list/sbs_projects/').then(res => res?.data)
  },
  async getSbsAgreements(sbs_company_guid, project_guid, sbs_partner_guid) {
    return await instance().post('/handbook/contractor_agreement_list/sbs_agreements/', {
      sbs_company_guid,
      project_guid,
      sbs_partner_guid
    }).then(res => res?.data)
  },
  async downloadAgreement(contractor_agreement_list_id) {
    const response = await instance().get(`/handbook/contractor_agreement_list/${contractor_agreement_list_id}/download/`, {
      responseType: 'blob'
    });
    return response;
  },
  async sendTo1C(contractor_agreement_list_id) {
    return await instance().post(`/handbook/contractor_agreement_list/${contractor_agreement_list_id}/send_to_1c/`).then(res => res?.data)
  },
  async sign(contractor_agreement_list_id) {
    return await instance()
      .post(`/handbook/contractor_agreement_list/${contractor_agreement_list_id}/sign/`)
      .then(res => res?.data);
  },
  async getSmetaMaterialsWithoutAgreement(params) {
    return await instance()
      .get('/project/provider_requests/materials-without-agreement/', { params })
      .then(res => res?.data);
  },
}

